/**
 * OD-33 (founder decision, revised 2026-10-15) — CORE-AU: a lift bay whose rated capacity is not on record no
 * longer refuses a vehicle. The physical gate (apply_vehicle_location_locked) allows the placement and marks it
 * `capacityNotVerified`; every surface that moves a vehicle shows the same warning. The warning never says the
 * pairing is safe and names no weight or capacity — none is known. A KNOWN violation (rated lift, known weight
 * above it) is still refused by the server and keeps its own dialog.
 */
export const CAPACITY_NOT_VERIFIED_TITLE = 'Capacity Not Verified';

export function capacityNotVerifiedDescription(bayName?: string | null): string {
  const where = bayName ? `${bayName} has` : 'This lift has';
  return `${where} no rated capacity on record. The vehicle was placed, but OptiBay has not verified that it is within the lift's capacity. Record the lift's rated capacity from its data tag to enable the capacity check.`;
}

/** True only when the server explicitly marked the placement as not capacity-verified. */
export function isCapacityNotVerified(result: unknown): boolean {
  return !!result && typeof result === 'object' && (result as { capacityNotVerified?: unknown }).capacityNotVerified === true;
}
